// v2/components/ProductThumb.js — urun gorseli: uzerine gelince onizleme,
// tiklayinca tam ekran galeri (urunun tum gorselleri arasinda gezinme)
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Package } from 'lucide-react';
import { TamEkran } from './ProductDetailModal';
import { urunGorseli, urunGorselleri } from '../utils/mapProduct';
import pt from './ProductTable.module.css';
import styles from './ProductThumb.module.css';

const ONIZLEME_W = 236;
const ONIZLEME_H = 250;
const GECIKME = 120;

export default function ProductThumb({ code, name = '', className = '', imgClassName = '' }) {
  const src = urunGorseli(code, 1);
  const [bozuk, setBozuk] = useState(false);
  const [pos, setPos] = useState(null);
  const [tamEkran, setTamEkran] = useState(false);
  const timer = useRef(null);

  useEffect(() => { setBozuk(false); }, [src]);
  useEffect(() => () => clearTimeout(timer.current), []);

  // onizleme acikken sayfa kayarsa / boyut degisirse kapat
  useEffect(() => {
    if (pos === null) return undefined;
    const kapat = () => setPos(null);
    window.addEventListener('scroll', kapat, true);
    window.addEventListener('resize', kapat);
    return () => {
      window.removeEventListener('scroll', kapat, true);
      window.removeEventListener('resize', kapat);
    };
  }, [pos]);

  const hazir = Boolean(src) && bozuk === false;

  const goster = (e) => {
    if (hazir === false) return;
    const r = e.currentTarget.getBoundingClientRect();
    const sagaSigar = r.right + 12 + ONIZLEME_W <= window.innerWidth;
    const left = sagaSigar ? r.right + 12 : Math.max(r.left - 12 - ONIZLEME_W, 8);
    const top = Math.min(Math.max(r.top - 60, 12), Math.max(window.innerHeight - ONIZLEME_H - 12, 12));
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setPos({ top, left }), GECIKME);
  };

  const gizle = () => {
    clearTimeout(timer.current);
    setPos(null);
  };

  const ac = () => {
    gizle();
    if (hazir) setTamEkran(true);
  };

  const kapat = useCallback(() => setTamEkran(false), []);

  return (
    <>
      <button
        type="button"
        className={`${styles.btn} ${className}`}
        onMouseEnter={goster}
        onMouseLeave={gizle}
        onClick={ac}
        disabled={hazir === false}
        aria-label={hazir ? `${name} görsellerini büyüt` : name}
        title={hazir ? 'Büyütmek için tıklayın' : undefined}
      >
        {hazir ? (
          <img className={imgClassName} src={src} alt={name} loading="lazy" decoding="async"
               onError={() => setBozuk(true)} />
        ) : (
          <Package size={16} strokeWidth={1.5} />
        )}
      </button>

      {pos && createPortal(
        <div className={pt.previewCard} aria-hidden="true"
             style={{ position: 'fixed', top: pos.top, left: pos.left, zIndex: 1200 }}>
          <div className={pt.previewBox}>
            <img className={pt.previewImg} src={src} alt="" decoding="async" />
          </div>
          <div className={pt.previewName}>{name}</div>
          <div className={pt.previewCode}>{code}</div>
        </div>,
        document.body
      )}

      {tamEkran && createPortal(
        <TamEkran kareler={urunGorselleri(code)} baslangic={0} baslik={name} code={code} onClose={kapat} />,
        document.body
      )}
    </>
  );
}
